import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

const retrieveDeliveryPriceForStandardOrder = async (orderId: string) => {
  const res = await api().gersGetDeliveryPrice(orderId);
  return res.data;
};

export const useGetStandardOrderDeliveryPrice = (orderId: string) => {
  const { data } = useQuery({
    queryKey: [`get-standard-order-delivery-price-${orderId}`],
    queryFn: () => retrieveDeliveryPriceForStandardOrder(orderId),
    enabled: orderId !== "",
  });

  return { deliveryPriceAmount: data?.amount ?? 0 };
};
